export const formatPlate = (value: string): string => {
    return value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 7);
};

export const formatCardNumber = (value: string): string => {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length !== 16) return cleaned;
    return `${cleaned.slice(0, 4)} ${cleaned.slice(4, 8)} ${cleaned.slice(8, 12)} ${cleaned.slice(12)}`;
};

export const formatNumericInput = (value: string, maxLength?: number): string => {
    const cleaned = value.replace(/\D/g, '');
    return maxLength ? cleaned.slice(0, maxLength) : cleaned;
};

export const formatMoneyInput = (value: string): string => {
    const cleaned = value.replace(/\D/g, '');
    
    if (!cleaned) return '';
    
    const cents = parseInt(cleaned, 10);
    
    const reais = Math.floor(cents / 100);
    const centavos = cents % 100;
    
    const formattedReais = reais.toString();
    const formattedCentavos = centavos.toString().padStart(2, '0');
    
    return `${formattedReais},${formattedCentavos}`;
};

export const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(value);
};

export const formatNumber = (value: number, decimals: number = 2): string => {
    return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(value);
};

export const formatLiters = (value: number): string => {
    return `${value.toFixed(1).replace('.', ',')} L`;
};

export const parseMoneyInput = (value: string): number => {
    return parseFloat(value.replace(',', '.')) || 0;
};

